/**
 * HOOK: useVehicles (VERSION REFACTORISÉE)
 * Utilise le hook useCRUD générique
 *
 * 🎯 Avant: 131 lignes | Après: 22 lignes | Réduction: 83%
 */

import type { Vehicle, CreateVehicleDto, UpdateVehicleDto } from '../types/vehicle';
import { useCRUD } from './useCRUD';

export function useVehicles() {
  const crud = useCRUD<Vehicle, CreateVehicleDto, UpdateVehicleDto>('vehicles', {
    select: '*, crew:crews(id, name)',
    orderBy: { column: 'registration', ascending: true },
  });

  return {
    // API spécifique (pour compatibilité)
    vehicles: crud.data,
    loading: crud.loading,
    error: crud.error,
    refreshVehicles: crud.refresh,
    getVehicleById: crud.getById,
    createVehicle: crud.create,
    updateVehicle: crud.update,
    deleteVehicle: crud.remove,
    deleteVehicles: crud.removeMany,

    // API générique (pour useEntityList)
    data: crud.data,
    create: crud.create,
    update: crud.update,
    remove: crud.remove,
    removeMany: crud.removeMany,
  };
}

/**
 * MIGRATION GUIDE:
 *
 * Ancien code:
 * const { vehicles, loading, error, createVehicle, updateVehicle, deleteVehicle } = useVehicles();
 *
 * Nouveau code:
 * const { data: vehicles, loading, error, create: createVehicle, update: updateVehicle, remove: deleteVehicle } = useVehicles();
 */
